import React, { useRef } from "react";
import Card from "../../shared/state-components/Card";
import { Link } from "react-router-dom";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import AgGridDataTable from "../../shared/utilities/AgGridDataTable";

const formatPhone = (phoneNo) => {
  let s2 = ("" + phoneNo).replace(/\D/g, "");
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

const TransporterEpaIds = (props) => {
  const agGridRef = useRef();
  const columnDefs = [
    {
      headerName: "ID Number", field: "EPA_ID", width: 160,
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      headerName: "Name", field: "FAC_NAME", width: 235,
      // cellRenderer: function (params) {
      //   if (params.data.EPA_ID != null) {
      //     return (
      //       `<a href="/facility/${params.data.EPA_ID}" target="_">` +
      //       params.value +
      //       "</a>"
      //     );
      //   }
      // },
    },
    {
      headerName: "Facility Address", field: "FAC_ADDRESS"
    },
    {
      headerName: "Status", field: "STATUS", width: 80
    },
    {
      headerName: "Issue Date", field: "ISSUE_DATE", width: 121
    },
    {
      headerName: "Inactive Date", field: "INACTIVE_DATE", width: 121
    },
    {
      headerName: "Phone", field: "PHONE", width: 130,
      cellRenderer: function (params) {
        if (params.value != null) {
          return formatPhone(params.value);
        }
      },
    },
    ...props.isRegulator ?
      [{
        headerName: "Email", field: "EMAIL"
      }] : [],
  ];

  return (

      <div className="facility-address-card">
     <h3
          style={{
            textAlign: "center",
          }}
        >
          Associated ID Numbers
        </h3>
        {props.epaIds.length == 0 ? <div>No ID Numbers associated with this Transporter Registration.</div> 
        : 
        
        <div>
          <AgGridDataTable
            pageTitle={`Transporter Profile: ${props.transName} (${props.regID})`}
            agGridRef={agGridRef}
            columnDefs={columnDefs}
            rowData={props.epaIds}
            initialPageSize={10}
            hidePagination={true}
          />
        </div>
        }
      </div>
     
  );
};

export default TransporterEpaIds;
